import axios, { AxiosRequestHeaders } from "axios";
import { useState } from "react";
import { ILoginData2 } from "../../../models";
import { HOSTNAME } from "../api-utils";
import { ApiTesterComponent, IApiFetcher } from "../ApiTesterApp";

export const tracksTopSalesGet: IApiFetcher = async ({
  utoken,
  omitUserAgent = false,
}: {
  utoken: string;
  omitUserAgent?: boolean;
}) => {
  const headers: AxiosRequestHeaders = {};
  if (!omitUserAgent) {
    headers["User-Agent"] = "I:2.5.0(256)";
  }
  headers["utoken"] = utoken;

  const response = await axios.get<any>(`${HOSTNAME}${tracksTopSalesGet.url}`, {
    headers,
  });
  return response.data;
};
tracksTopSalesGet.url = "/wp-json/wp/v3/tracks/top_sales";
tracksTopSalesGet.method = 'GET';

const TracksTopSales: ApiTesterComponent = ({
  loginData,
}: {
  loginData: ILoginData2 | null;
}) => {
  const [data, setData] = useState<string>("");
  const [loading, setIsLoading] = useState<boolean>(false);

  const onFetch = () => {
    if (!loginData?.token) return;

    setIsLoading(true);
    tracksTopSalesGet({
      utoken: loginData.token,
      omitUserAgent: true,
    }).then((data) => {
      setIsLoading(false);
      setData(JSON.stringify(data, null, 2));
    });
  };

  return (
    <div>
      <h3>TracksTopSales</h3>

      <button onClick={onFetch}>Fetch</button>
      <pre>{loading ? "Loading..." : data}</pre>
    </div>
  );
};

TracksTopSales.fetcher = tracksTopSalesGet;

export default TracksTopSales;
